/**
 * Simple emoji picker — hardcoded grid of ~50 popular emoji.
 * No library dependency. Inserts selected emoji at cursor position.
 */

const EMOJIS = [
  '\uD83D\uDE00', '\uD83D\uDE02', '\uD83D\uDE05', '\uD83D\uDE0E', '\uD83E\uDD29', '\uD83D\uDE09', '\uD83D\uDE0D', '\uD83E\uDD23',
  '\uD83D\uDE18', '\uD83D\uDE1C', '\uD83E\uDD14', '\uD83D\uDE31', '\uD83D\uDE24', '\uD83D\uDE22', '\uD83D\uDE2D', '\uD83E\uDD2F',
  '\uD83D\uDC4D', '\uD83D\uDC4E', '\uD83D\uDC4F', '\u270C\uFE0F', '\u2764\uFE0F', '\uD83D\uDD25', '\uD83C\uDF89', '\u2B50',
  '\uD83D\uDCA1', '\uD83D\uDCAA', '\uD83D\uDE80', '\uD83C\uDFC6', '\uD83C\uDFAF', '\uD83D\uDCA3', '\uD83D\uDD12', '\uD83D\uDD11',
  '\uD83D\uDCCD', '\uD83D\uDDFA\uFE0F', '\uD83C\uDFE0', '\uD83C\uDF03', '\uD83C\uDF19', '\u26A0\uFE0F', '\u2705', '\u274C',
  '\uD83D\uDE97', '\uD83D\uDEA8', '\uD83D\uDCA8', '\uD83C\uDF1F', '\u23F0', '\uD83D\uDCA4', '\uD83C\uDFB5', '\uD83D\uDC7B'
];

export function createEmojiPicker(
  container: HTMLElement,
  onSelect: (emoji: string) => void
): { toggle: () => void; destroy: () => void } {
  const panel = document.createElement('div');
  panel.style.cssText = `
    display: none; position: absolute; bottom: 100%; left: 0; z-index: 100;
    background: var(--bg-surface, #141420); border: 1px solid var(--bg-border, #2A2A40);
    border-radius: 8px; padding: 8px; width: 280px;
    grid-template-columns: repeat(8, 1fr); gap: 2px;
    max-height: min(70vh, 360px); overflow-y: auto;
  `;

  for (const emoji of EMOJIS) {
    const cell = document.createElement('button');
    cell.type = 'button';
    cell.textContent = emoji;
    cell.style.cssText = `
      background: none; border: none; font-size: 22px; padding: 4px;
      cursor: pointer; border-radius: 4px; line-height: 1;
    `;
    cell.addEventListener('mouseenter', () => { cell.style.background = 'var(--bg-card, #1C1C2E)'; });
    cell.addEventListener('mouseleave', () => { cell.style.background = 'none'; });
    cell.addEventListener('click', () => {
      onSelect(emoji);
      toggle();
    });
    panel.appendChild(cell);
  }

  let visible = false;
  function toggle() {
    visible = !visible;
    panel.style.display = visible ? 'grid' : 'none';
  }

  // Close on outside click
  const closeHandler = (e: Event) => {
    if (visible && !container.contains(e.target as Node)) {
      visible = false;
      panel.style.display = 'none';
    }
  };
  document.addEventListener('click', closeHandler);

  container.appendChild(panel);

  return {
    toggle,
    destroy() {
      document.removeEventListener('click', closeHandler);
      panel.remove();
    }
  };
}
